import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Routes from "../../../../data/Routes";
import PermissionHelper from "../../../../tools/permissions/PermissionHelper";
import SubMenu from "../sub-menu/SubMenu";
import { ISystemSubMenuProps } from "./ISystemSubMenuProps";

export default class SystemSubMenu extends Component<ISystemSubMenuProps> {
  render() {
    return (
      <>
        <SubMenu>
          <LinkContainer to={Routes.systemHeartbeats}>
            <Nav.Link><span className="navItemLink">Heartbeats</span></Nav.Link>
          </LinkContainer>

          <LinkContainer to={Routes.systemPerformance}>
            <Nav.Link><span className="navItemLink">Performance</span></Nav.Link>
          </LinkContainer>

          <LinkContainer to={Routes.systemLogs}>
            <Nav.Link><span className="navItemLink">Logs</span></Nav.Link>
          </LinkContainer>

          {
            PermissionHelper.doesUserHavePermissionGlobally(PermissionHelper.getAllPermissions().SYS_SETTINGS)
              ?
              <LinkContainer to={Routes.systemSettings}>
                <Nav.Link><span className="navItemLink">Settings</span></Nav.Link>
              </LinkContainer>
              : null
          }

          {
            PermissionHelper.doesUserHavePermissionGlobally(PermissionHelper.getAllPermissions().SYS_SECURITY)
            ?
              <LinkContainer to={Routes.systemSecurity}>
                <Nav.Link><span className="navItemLink">Security</span></Nav.Link>
              </LinkContainer>
            : null
          }
        </SubMenu>
      </>
    );
  }
}
